import { AABBBounds } from "@visactor/vutils";

export class CurvePath {
    constructor() {
        this.curves = [], this.bounds = new AABBBounds;
    }
    getCurveLengths() {
        return this.curves.map((curve => curve.getLength()));
    }
    getPointAt(t) {
        return {
            x: 0,
            y: 0
        };
    }
    getLength() {
        return 0;
    }
    getBounds() {
        return this.bounds;
    }
}
//# sourceMappingURL=path.js.map
